import Model from '@/Apis/NotificationsActions'
import Controller from './Controller'

export default class NotificationsactionsController extends Controller {
  constructor() {
    super(new Model())
  }
  async getNotifications() {
    const response = await this.model.getNotifications()
    return response

  }
  //ReadNotifications
  async ReadNotifications(params) {
    const response = await this.model.ReadNotifications(params)
    return response

  }
  async ReadOneNotification(params) {
    const response = await this.model.ReadOneNotification(params)
    return response

  }
  async ToggleActivation(id,key){
    const res = await this.model.ToggleActivation(id,key)
    return this.Poup(res);
  }
  // async ToggleActivation(user) {
  //   const res = await this.model.ToggleActivation(user)
  //   return this.Poup(res);

  // }

}
